/**
 * Global Imports
*/

import React, { Fragment, useState } from 'react';

/**
 * Root Imports
*/



/**
 * Local Imports
*/



/**
 * Exports
*/

export function VerifiedLayout(props) {
  /** States **/
  
  
  
  /** Output **/
  
  return (
    <Fragment>
      <div>Verified</div>
    </Fragment>
  );
}